import { h5, h6 } from '@repo/ui/components/Typography';
import { QUERIES } from '@repo/ui/queries';
import styled from 'styled-components';

export const SmallHeading = styled.h5`
  ${h6};

  ${QUERIES.largeTabletAndUp} {
    ${h5};
  }
`;
